var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalAuthorsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.231,
    height: 78.512,
    viewBox: "0 0 66.231 78.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "totalAuthorsIcon",
    transform: "translate(-637.364 -328.812)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5267",
    "data-name": "Rectangle 5267",
    width: 65.231,
    height: 77.512,
    transform: "translate(637.864 329.312)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14479",
    "data-name": "Group 14479",
    transform: "translate(654.252 349.49)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_705",
    "data-name": "Ellipse 705",
    cx: 8.273,
    cy: 8.273,
    r: 8.273,
    transform: "translate(7.954 0)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11306",
    "data-name": "Path 11306",
    d: "M677.838,385.618a18.452,18.452,0,0,0-14.908,7.559,6.9,6.9,0,0,0,5.635,10.918h18.547a6.9,6.9,0,0,0,5.635-10.918A18.452,18.452,0,0,0,677.838,385.618Z",
    transform: "translate(-661.611 -366.94)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAuthorsIcon);
export default __webpack_public_path__ + "static/media/totalAuthorsIcon.a8956e0f1bbd391c0fa0663cbe3d000d.svg";
export { ForwardRef as ReactComponent };